import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import i18n from 'i18next';

import { GET_USERS_LIST_BY_TYPE, UPDATE_STATUS, UPDATE_USER } from "./actionTypes";
import { registerUsersByType, userSuccess, updateUsersSuccess, updateUsersFail } from "./actions";

import service from '../../../api/user.service';

function* getUserList({ payload: { data } }) {
  try {
    const response = yield service.getUsers(data).then((r) => {
      return r.data !== undefined ? r.data : r.response.data;
    });
    yield put(registerUsersByType(response));
  } catch (error) {
    yield put(userSuccess({
      type: "error",
      text: error.message
    }));
  }
}

function* updateStatus({ payload: { data } }) {
  try {
    const response = yield call(service.updateStatus, data)

    const error = response?.response?.data?.error;
    if (error) {
      yield put(userSuccess({
        type: "error",
        text: error
      }));
    } else {
      yield put(userSuccess({
        type: "success",
        text: i18n.t("users:msg")
      }));
    }
  } catch (error) {
    yield put(userSuccess({
      type: "error",
      text: error.message
    }));
  }
}
function* updateStatusUser(data) {
  try {
    const response = yield service.updateUser(data).then((r) => {
      return r.data !== undefined ? r.data : r.response.data;
    });
    const error = response?.response?.data?.error
    if (error) {
      yield put(updateUsersFail(error))
    } else {
      yield put(updateUsersSuccess(response))
    }
  } catch (error) {
    yield put(updateUsersFail(error))
  }
}


export function* watchUserRegister() {
  yield takeEvery(GET_USERS_LIST_BY_TYPE, getUserList);
  yield takeEvery(UPDATE_STATUS, updateStatus);
  yield takeEvery(UPDATE_USER, updateStatusUser);
}

function* accountSaga() {
  yield all([fork(watchUserRegister)])
}

export default accountSaga;